import { WA } from "@/lib/whatsapp";
import { FaWhatsapp } from "react-icons/fa";

/**
 * WhatsApp CTA rendered as an anchor. Every primary CTA on the site uses this.
 */
export const WhatsAppButton = ({
  children,
  href,
  variant = "primary",
  size = "md",
  className = "",
  showIcon = true,
  iconColor = "#25D366",
  testId = "whatsapp-cta",
}) => {
  const url = href || WA.general();
  const base = "inline-flex items-center justify-center gap-2 rounded-full font-sans font-medium tracking-[0.02em] transition-colors duration-300 transform hover:scale-105 hover:shadow-md transition-transform duration-250 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lux-gold-soft focus-visible:ring-offset-2 focus-visible:ring-offset-lux-ivory";
  const sizes = {
    sm: "h-10 px-5 text-sm",
    md: "h-12 px-7 text-sm",
    lg: "h-14 px-9 text-base",
  };
  const variants = {
    primary: "bg-lux-charcoal text-lux-ivory hover:bg-lux-charcoal-2",
    secondary:
      "bg-lux-warm-white text-lux-charcoal border border-border hover:bg-lux-beige",
    outline:
      "bg-transparent text-lux-ivory border border-white/60 hover:bg-white/10 backdrop-blur-[2px]",
    ghost: "bg-transparent text-lux-charcoal hover:text-lux-gold",
  };
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
    >
      {showIcon && <FaWhatsapp className="h-4 w-4" style={{ color: iconColor }} aria-hidden="true" />}
      {children}
    </a>
  );
};
